/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AaInputs */

const en_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

const es_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

const fr_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

const de_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

const ja_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

const zh_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

const ar_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

const id_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

const it_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

const ru_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аа`)
};

const pt_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

const ko_aa = /** @type {(inputs: AaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aa`)
};

/**
* | output |
* | --- |
* | "Aa" |
*
* @param {AaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const aa = /** @type {((inputs?: AaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aa(inputs)
	if (locale === "es") return es_aa(inputs)
	if (locale === "fr") return fr_aa(inputs)
	if (locale === "de") return de_aa(inputs)
	if (locale === "ja") return ja_aa(inputs)
	if (locale === "zh") return zh_aa(inputs)
	if (locale === "ar") return ar_aa(inputs)
	if (locale === "id") return id_aa(inputs)
	if (locale === "it") return it_aa(inputs)
	if (locale === "ru") return ru_aa(inputs)
	if (locale === "pt") return pt_aa(inputs)
	return ko_aa(inputs)
});